import { useEffect } from 'react';

import Sentry from 'src/services/sentry';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { isExamInProgress } from 'src/utils/isExamInProgress';

// Tags the exam an event belongs to. Neither id is PHI. Clearing them when the exam ends is
// what stops a later error being attributed to a finished exam.
const useSentryExamScope = (): void => {
  const examId = useRemoteBoundStore((s) => s.session?.iid);
  const orderId = useRemoteBoundStore((s) => s.session?.orderId);

  useEffect(() => {
    const inExam = isExamInProgress(examId);
    Sentry.setTags({
      exam_id: inExam ? examId : null,
      // orderId can drop transiently mid-exam; iid holds for the whole exam.
      order_id: inExam ? (orderId ?? null) : null,
    });
  }, [examId, orderId]);
};

export default useSentryExamScope;
